module.exports = __webpack_public_path__ + "img/greypanel.572dbce1.svg";